import axios, { type AxiosInstance } from "axios";

import { ApiService } from "@/Services/Api";
import { config } from "@/Common/envConfig";
import { APP_ROUTES } from "@/Generated/Routes/paths";
import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";

import AppRouter from "@/Router";

import { useAuthStore } from "@/Modules/Auth/Store";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import { isValidString } from "@/Utils/String";
import { hasValue } from "@/Utils/Objects";

class TherapySideApiService extends ApiService {
  constructor(
    hasUnAuthInterceptor: boolean = true,
    private readonly authStore = useAuthStore()
  ) {
    super(config.apiUrl);

    this.setRequestInterceptor(this.client);

    if (hasUnAuthInterceptor) {
      this.setUnauthorizedInterceptor(this.client);
    }
  }

  private setUnauthorizedInterceptor(axiosInstance: AxiosInstance) {
    axiosInstance.interceptors.response.use(
      (response) => response,
      (error: unknown) => {
        if (axios.isAxiosError(error)) {
          const isLoginRoute = AppRouter.router.currentRoute.value.name === APP_ROUTES.login.root.name;
          const isLogoutRoute = error.config?.url?.includes("logout");

          if (error.response?.status === 401 && !isLoginRoute && !isLogoutRoute) {
            this.authStore.logout();
          }

          if (hasValue(error.response) && hasValue(error.response.data) && isApiError(error.response.data)) {
            if (error.response.data.error_code === ApiErrorCodes.USER_LOGED_OUT) {
              this.authStore.logout();
            }
          }

          return Promise.reject(error.response?.data);
        }
      }
    );
  }

  private setRequestInterceptor(axiosInstance: AxiosInstance) {
    axiosInstance.interceptors.request.use((request) => {
      const token = this.authStore.userToken ?? "";

      //request.headers["X-Therapyside-version"] = config.packageVersion;

      if (isValidString(token)) {
        request.headers.Authorization = `Bearer ${token}`;
      }

      return request;
    });
  }
}

export default TherapySideApiService;
